module.exports = "pegasus_template/assets/square-snapchat.png";